// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 768px) {\n    .container {\n        width: 750px;\n    }\n}\n@media (min-width: 992px) {\n    .container {\n        width: 970px;\n    }\n}\n@media (min-width: 1200px) {\n    .container {\n        width: 1170px;\n    }    \n}\n.container {\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
